import { useEffect } from "react";

/**
 * Custom hook to update the browser tab title
 * @param title - The main title to display
 * @param subtitle - Optional subtitle to append
 */
export const useDocumentTitle = (title: string, subtitle?: string) => {
  useEffect(() => {
    if (title) {
      document.title = `Unruly | ${title}${subtitle ? " - " + subtitle : ""}`;
    } else {
      document.title = "Unruly";
    }

    return () => {
      document.title = "Unruly";
    };
  }, [title, subtitle]);
};
